import { render, staticRenderFns } from "./SignUpFooter.vue?vue&type=template&id=8c910138&scoped=true&lang=pug"
import script from "./SignUpFooter.js?vue&type=script&lang=js&external"
export * from "./SignUpFooter.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c910138",
  null
  
)

export default component.exports